import { gql } from '@apollo/client';
import { NEW_GENERIC_ORDER } from '../fragments/generic-order';

export const GET_GENERIC_ORDER_BY_ID = gql`
  query GetGenericOrderById($id: ID!) {
    genericOrder(id: $id) { ...NewGenericOrder }
  }
  ${NEW_GENERIC_ORDER}
`;

const GENERIC_ORDER_LIST_FIELDS = gql`
  fragment GenericOrderListFields on GenericOrderList {
    genericOrders { ...NewGenericOrder }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
  ${NEW_GENERIC_ORDER}
`;

export const GET_GENERIC_ORDERS = gql`
  query GetGenericOrders($input: FilterGenericList!) {
    genericOrders(input: $input) {
      ...GenericOrderListFields
    }
  }
  ${GENERIC_ORDER_LIST_FIELDS}
`;

export const GET_GENERIC_ORDERS_MODAL = gql`
  query GetGenericOrdersModal($input: FilterGenericList!) {
    genericOrders(input: $input) @connection(key: "modal") {
      ...GenericOrderListFields
    }
  }
  ${GENERIC_ORDER_LIST_FIELDS}
`;
